<div class="modal">
  <div class="container">
    <slot />
  </div>
</div>

<style>
.modal {
  background: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: auto;
}
.container {
  margin: auto;
  padding: 10px;
  background: #D77C33;
  border-radius: 10px;
  box-shadow:  4px 4px #303030;
}

</style>